import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {LeftArrowIcon, RegionModalOtherRegionsArrowIcon} from '@amblique/king-living/app/components/icons';
import {ensureArray} from '@amblique/king-living/app/utils/utils';
import {
  Box, Text, useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui';
import {Link as ContentfulLink} from '@amblique/king-living/app/contentful/models/link';

import {
  MenuItemContent,
  getLinkDisplayText,
  toShopAllLink,
} from '@amblique/king-living/app/components/mega-menu/shared/menu-item-container';

export const MegaMenuSubcategoryPanel = ({
  category,
  onBackClick,
  transform = 'translateX(100%)',
  zIndex = 3,
  ...props
}) => {
  const styles = useMultiStyleConfig('MegaMenu', {});

  const submenuItems = ensureArray(category?.submenuCollection?.items).filter(Boolean);

  return (
    <Box
      className="mega-menu-subcategory-panel"
      {...styles.mobileSubcategoryPanel}
      transform={transform}
      zIndex={zIndex}
      {...props}
      sx={{
        willChange: 'transform',
        ...props.sx,
      }}
    >
      <Box className="mega-menu-subcategory-panel-wrapper" {...styles.mobileSubcategoryPanelWrapper}>
        <Box className="mega-menu-subcategory-panel-wrap" {...styles.mobileSubcategoryPanelWrap}>
          {onBackClick && (
            <Box
              as="button"
              className="mega-menu-subcategory-panel-back-button"
              data-testid="mega-menu-subcategory-panel-back-button"
              type="button"
              onClick={onBackClick}
              {...styles.backButtonWrapper}
            >
              <LeftArrowIcon {...styles.backButtonIcon} />
              <Text as="span" {...styles.backButton}>
                <FormattedMessage defaultMessage="Back" id="mega_menu.back_button" />
              </Text>
            </Box>
          )}
          {category?.featuredLink && (
            <Box className="mega-menu-subcategory-panel-shop-all-link-wrapper" {...styles.shopAllLinkWrapper}>
              <ContentfulLink className="shop-all-link" component={toShopAllLink(category.featuredLink)}>
                {getLinkDisplayText(category.featuredLink)}
                <RegionModalOtherRegionsArrowIcon {...styles.shopAllTitleIcon} />
              </ContentfulLink>
            </Box>
          )}
          <MenuItemContent
            isMobile={true}
            menuItem={category}
            submenuItems={submenuItems}
          />
        </Box>
      </Box>
    </Box>
  );
};

MegaMenuSubcategoryPanel.displayName = 'MegaMenuSubcategoryPanel';
MegaMenuSubcategoryPanel.propTypes = {
  category: PropTypes.object.isRequired,
  onBackClick: PropTypes.func.isRequired,
  transform: PropTypes.string,
  zIndex: PropTypes.number,
};
